import {
  addUserAndAssignToSubAdminAPI,
} from "./api";

export function addUserAndAssignToSubAdmin(data) {
  return new Promise((resolve, reject) => {
    addUserAndAssignToSubAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
